<template>
  <div class="container">
    <button class="button is-primary is-small is-pulled-right" @click="add">
      <span class="icon">
        <i class="fas fa-plus"></i>
      </span>
      <span>Cadastrar</span>
    </button>
    <br><br>

    <div class="modal" :class="{ 'is-active': isShowModal }">
      <div class="modal-background" v-on:click="isShowModal = false"></div>
      <div class="modal-card">
        <header class="modal-card-head has-background-primary">
          <p class="modal-card-title has-text-white">Cadastrar</p>
          <button class="delete" aria-label="close" v-on:click="isShowModal = false"></button>
        </header>
        <section class="modal-card-body">
          <form v-if="!mostraDREVersaoConfig && !mostraCompartilhamento">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Descrição</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <input class="input" type="text" placeholder="Informe a descrição do demonstrativo de resultado" v-model="demonstracaoResultadoVersao.descricao">
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Nome da Fórmula</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <input class="input" type="text" placeholder="Informe o nome da fórmula" v-model="demonstracaoResultadoVersao.nome_formula">
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Comentários</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <textarea class="textarea" placeholder="Comente sobre esse demonstrativo de resultado" v-model="demonstracaoResultadoVersao.comentario"></textarea>
                  </p>
                </div>
              </div>
            </div>
          </form>

          <form v-if="mostraCompartilhamento">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Versão</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select v-model="demonstracaoResultadoCompartilhar.versao_plano_contas">
                        <option v-for="versao_plano_contas in versoesPlanoContas" :key="versao_plano_contas.id" :value="versao_plano_contas">
                          {{ versao_plano_contas.descricao }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <form v-if="mostraDREVersaoConfig">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Descrição</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <input class="input" type="text" placeholder="Informe a descrição da linha da demonstração do resultado" v-model="demonstracaoResultadoVersaoConfig.descricao">
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Sequencial</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <input class="input" type="text" v-model="demonstracaoResultadoVersaoConfig.sequencial">
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Negrito</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="select is-fullwidth">
                    <select v-model="demonstracaoResultadoVersaoConfig.eNegrito">
                      <option value="S">Sim</option>
                      <option value="N">Não</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Desejada</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="select is-fullwidth">
                    <select v-model="demonstracaoResultadoVersaoConfig.tipo_evolucao_desejada">
                      <option value="A">Alta</option>
                      <option value="B">Baixa</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Referência AV</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="select is-fullwidth">
                    <select v-model="demonstracaoResultadoVersaoConfig.referencia_av">
                      <option value="S">Sim</option>
                      <option value="N">Não</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Fórmula</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <textarea class="textarea" placeholder="Informe a fórmula para preenchimento" v-model="demonstracaoResultadoVersaoConfig.formula"></textarea>
                  </p>
                </div>
              </div>
            </div>
          </form>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success" @click="save">Salvar</button>
          <button class="button" v-on:click="isShowModal = false">Cancelar</button>
        </footer>
      </div>
    </div>

    <div class="columns">
      <div class="column is-5">
        <div class="card">
          <header class="card-header has-background-primary">
            <p class="card-header-title has-text-white">Demonstrações de Resultados</p>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Descrição</th>
                    <th>Comentários</th>
                    <th class="has-text-centered">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(dre, index) in demonstrativosResultados" :key="dre.id">
                    <td>{{ dre.descricao }}</td>
                    <td>{{ dre.comentario }}</td>
                    <td class="has-text-centered">
                      <div class="buttons is-centered">
                        <button class="button is-small is-info is-outlined" @click="edit(index)" :disabled="mostraCompartilhamento || mostraDREVersaoConfig" title="Editar">
                          <span class="icon is-small">
                            <i class="fas fa-edit"></i>
                          </span>
                        </button>
                        <button class="button is-small is-danger is-outlined" @click="erase(index)" :disabled="mostraCompartilhamento || mostraDREVersaoConfig" title="Excluir">
                          <span class="icon is-small">
                            <i class="fas fa-trash-alt"></i>
                          </span>
                        </button>
                        <button class="button is-small is-primary is-outlined" @click="callCompartilhar(dre)" :disabled="mostraCompartilhamento || mostraDREVersaoConfig" title="Compartilhar">
                          <span class="icon is-small">
                            <i class="fas fa-share-alt"></i>
                          </span>
                        </button>
                        <button class="button is-small is-success is-outlined" @click="callDREConfig(dre)" :disabled="mostraCompartilhamento || mostraDREVersaoConfig" title="Configurar">
                          <span class="icon is-small">
                            <i class="fas fa-th-list"></i>
                          </span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="column" v-show="mostraCompartilhamento">
        <div class="card">
          <header class="card-header has-background-grey">
            <p class="card-header-title has-text-white">Compartilhar {{ dreVersaoSelecionado.descricao }}</p>
            <a class="card-header-icon" @click="mostraCompartilhamento = false">
              <span class="icon">
                <i class="fas fa-times"></i>
              </span>
            </a>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Versão</th>
                    <th class="has-text-centered">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(dreVersao, index) in demonstracaoResultadoVersoes" :key="dreVersao.id">
                    <td>{{ dreVersao.versao_plano_contas.descricao }}</td>
                    <td class="has-text-centered">
                      <button class="button is-small is-danger is-outlined" @click="erase(index)" title="Excluir">
                        <span class="icon is-small">
                          <i class="fas fa-trash-alt"></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <footer class="card-footer">
            <a @click="mostraCompartilhamento = false" class="card-footer-item">Fechar</a>
          </footer>
        </div>
      </div>

      <div class="column" v-show="mostraDREVersaoConfig">
        <div class="card">
          <header class="card-header has-background-grey">
            <p class="card-header-title has-text-white">Linhas da Demonstração de Resultado {{ dreVersaoSelecionado.descricao }}</p>
            <a class="card-header-icon" @click="mostraDREVersaoConfig = false">
              <span class="icon">
                <i class="fas fa-times"></i>
              </span>
            </a>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Sequencial</th>
                    <th>Descrição</th>
                    <th class="has-text-centered">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(linha, index) in linhasDemonstracaoResultado" :key="linha.id">
                    <td>{{ linha.sequencial }}</td>
                    <td>{{ linha.descricao }}</td>
                    <td class="has-text-centered">
                      <div class="buttons is-centered">
                        <button class="button is-small is-info is-outlined" @click="edit(index)" title="Editar">
                          <span class="icon is-small">
                            <i class="fas fa-edit"></i>
                          </span>
                        </button>
                        <button class="button is-small is-danger is-outlined" @click="erase(index)" title="Excluir">
                          <span class="icon is-small">
                            <i class="fas fa-trash-alt"></i>
                          </span>
                        </button>
                        <button class="button is-small is-success is-outlined" @click="abrirFormulas(linha)" title="Fórmula do perfil">
                          <span class="icon is-small">
                            <i class="fas fa-calculator"></i>
                          </span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <footer class="card-footer">
            <a @click="mostraDREVersaoConfig = false" class="card-footer-item">Fechar</a>
          </footer>
        </div>
      </div>
    </div>
    
    <dre-formula-perfil v-if="linhaSelecionada" :key="linhaSelecionada.id" :visivel="mostrarFormulas" :linha="linhaSelecionada" @fechar="fecharFormulas"/>

  </div>
</template>

<script>
import { http } from '../../services/config'
import DreFormulaPerfil from './DemonstracaoResultadoFormulaPerfil.vue'

export default {
  name: "DemonstracaoResultadoVersao",

  components: { DreFormulaPerfil },        

  data() {
    return {
      demonstracaoResultadoVersao: {
        id: null,
        descricao: null,
        comentario: null,
        nome_formula: null,
        versaoPlanoContas: null
      },
      demonstracaoResultadoCompartilhar: {
        id: null,
        demonstracao_resultado_versao: null,
        versao_plano_contas: null
      },
      demonstracaoResultadoVersaoConfig: {
        id: null,
        sequencial: null,
        descricao: null,
        eNegrito: "N",
        indentacao: 0,
        formula: null,
        tipo_evolucao_desejada: "A",
        referencia_av: "N"
      },
      versoesPlanoContas: [],
      demonstrativosResultados: [],
      linhasDemonstracaoResultado: [],
      demonstracaoResultadoVersoes: [],
      isShowModal: false,
      mostraDREVersaoConfig: false,
      mostraCompartilhamento: false,
      dreVersaoSelecionado: {
        id: null,
        descricao: null
      },
      previous: null,
      next: null,
      page: null,
      numpages: null,
      mostrarFormulas: false,
      linhaSelecionada: null,
    }
  },
  methods: {
    abrirFormulas(linha) {
      this.linhaSelecionada = linha;
      this.mostrarFormulas = true;
    },       
    
    fecharFormulas() {
      this.mostrarFormulas = false;
      this.linhaSelecionada = null;
    },            

    add() {
      this.clearFields()
      this.isShowModal = true
    },
    edit(index) {
      if (!this.mostraDREVersaoConfig && !this.mostraCompartilhamento) {
        this.demonstracaoResultadoVersao.id = this.demonstrativosResultados[index].id
        this.demonstracaoResultadoVersao.descricao = this.demonstrativosResultados[index].descricao
        this.demonstracaoResultadoVersao.nome_formula = this.demonstrativosResultados[index].nome_formula
        this.demonstracaoResultadoVersao.comentario = this.demonstrativosResultados[index].comentario
        this.demonstracaoResultadoVersao.index = index
      } else {
        this.demonstracaoResultadoVersaoConfig.id = this.linhasDemonstracaoResultado[index].id
        this.demonstracaoResultadoVersaoConfig.descricao = this.linhasDemonstracaoResultado[index].descricao
        this.demonstracaoResultadoVersaoConfig.sequencial = this.linhasDemonstracaoResultado[index].sequencial
        this.demonstracaoResultadoVersaoConfig.eNegrito = this.linhasDemonstracaoResultado[index].e_negrito ? "S" : "N"
        this.demonstracaoResultadoVersaoConfig.indentacao = this.linhasDemonstracaoResultado[index].indentacao
        this.demonstracaoResultadoVersaoConfig.formula = this.linhasDemonstracaoResultado[index].formula
        this.demonstracaoResultadoVersaoConfig.demonstracaoResultadoVersao = this.dreVersaoSelecionado
        this.demonstracaoResultadoVersaoConfig.tipo_evolucao_desejada = this.linhasDemonstracaoResultado[index].tipo_evolucao_desejada
        this.demonstracaoResultadoVersaoConfig.referencia_av = this.linhasDemonstracaoResultado[index].referencia_av
        this.demonstracaoResultadoVersaoConfig.index = index
      }
      this.isShowModal = true
    },
    erase(index) {
      if (window.confirm('Confirma exclusão?')) {
        if (!this.mostraDREVersaoConfig && !this.mostraCompartilhamento) {
          http.delete('/demonstracaoResultadoVersao/excluir/' + this.demonstrativosResultados[index].id)
            .then(response => {
              this.demonstrativosResultados.splice(index, 1)
              if (response.status === 204) {
                alert('Registro excluído!')
              }
            })
            .catch(e => {
              console.error('Erro ao excluir:', e)
            })
        } else if (this.mostraCompartilhamento) {
          http.delete('/demonstracaoResultadoVersao/excluirVersoes/' + this.demonstracaoResultadoVersoes[index].id)
            .then(response => {
              this.demonstracaoResultadoVersoes.splice(index, 1)
              if (response.status === 204) {
                alert('Registro excluído!')
              }
            })
            .catch(e => {
              console.error('Erro ao excluir:', e)
            })
        } else {
          http.delete('/demonstracaoResultadoVersaoConfig/excluir/' + this.linhasDemonstracaoResultado[index].id)
            .then(response => {
              this.linhasDemonstracaoResultado.splice(index, 1)
              if (response.status === 204) {
                alert('Registro excluído!')
              }
            })
            .catch(e => {
              console.error('Erro ao excluir:', e)
            })
        }
      }
    },
    callCompartilhar(dreVersao) {
      this.mostraCompartilhamento = true
      this.dreVersaoSelecionado = dreVersao
      http.get('demonstracaoResultadoVersao/listarVersoes/', { params: { idDemonstracaoResultadoVersao: this.dreVersaoSelecionado.id } })
        .then(response => {
          this.demonstracaoResultadoVersoes = response.data.results
        })
        .catch(e => {
          console.error('Erro ao listar versões:', e)
        })
    },
    clearFields() {
      if (!this.mostraDREVersaoConfig && !this.mostraCompartilhamento) {
        this.demonstracaoResultadoVersao = {
          id: null,
          descricao: null,
          comentario: null,
          nome_formula: null,
          index: null
        }
      } else if (this.mostraCompartilhamento) {
        this.demonstracaoResultadoCompartilhar = {
          id: null,
          demonstracao_resultado_versao: null,
          versao_plano_contas: null
        }
      } else {
        this.demonstracaoResultadoVersaoConfig = {
          id: null,
          sequencial: null,
          descricao: null,
          eNegrito: "N",
          indentacao: 0,
          formula: null,
          demonstracaoResultadoVersao: this.dreVersaoSelecionado,
          tipo_evolucao_desejada: "A",
          referencia_av: "N",
          index: null
        }
      }
    },
    callDREConfig(dreVersao) {
      this.mostraDREVersaoConfig = true
      this.dreVersaoSelecionado = dreVersao
      http.get('demonstracaoResultadoVersaoConfig/listar/', { params: { idDemonstracaoResultadoVersao: this.dreVersaoSelecionado.id } })
        .then(response => {
          this.linhasDemonstracaoResultado = response.data.results
        })
        .catch(e => {
          console.error('Erro ao listar configurações:', e)
        })
    },
    async save() {
      let data
      try {
        if (!this.mostraDREVersaoConfig && !this.mostraCompartilhamento) {
          if (!this.demonstracaoResultadoVersao.descricao) {
            alert('Descrição da demonstração do resultado não preenchida!')
            return
          }
          if (!this.demonstracaoResultadoVersao.nome_formula) {
            alert('Nome da fórmula não preenchida!')
            return
          }

          data = {
            id: this.demonstracaoResultadoVersao.id,
            usuario: this.$store.state.idUser,
            descricao: this.demonstracaoResultadoVersao.descricao,
            nome_formula: this.demonstracaoResultadoVersao.nome_formula,
            comentario: this.demonstracaoResultadoVersao.comentario
          }

          const formData = new FormData()
          Object.keys(data).forEach(key => formData.append(key, data[key]))

          if (!this.demonstracaoResultadoVersao.id) {
            const response = await http.post('/demonstracaoResultadoVersao/adicionar', formData)
            if (response.data.id) {
              this.demonstracaoResultadoVersao.id = response.data.id
              this.demonstrativosResultados.push({ ...this.demonstracaoResultadoVersao })
              this.clearFields()
              this.isShowModal = false
            } else {
              alert(response.request.responseText)
            }
          } else {
            const response = await http.put('/demonstracaoResultadoVersao/editar/' + this.demonstracaoResultadoVersao.id, formData)
            this.demonstrativosResultados[this.demonstracaoResultadoVersao.index].descricao = response.data.descricao
            this.demonstrativosResultados[this.demonstracaoResultadoVersao.index].nome_formula = this.demonstracaoResultadoVersao.nome_formula
            this.demonstrativosResultados[this.demonstracaoResultadoVersao.index].comentario = this.demonstracaoResultadoVersao.comentario
            this.isShowModal = false
          }
        } else if (this.mostraCompartilhamento) {
          if (!this.demonstracaoResultadoCompartilhar.versao_plano_contas) {
            alert('Versão não informada!')
            return
          }

          data = {
            id: this.demonstracaoResultadoCompartilhar.id,
            demonstracao_resultado_versao: this.dreVersaoSelecionado.id,
            versao_plano_contas: this.demonstracaoResultadoCompartilhar.versao_plano_contas.id
          }

          if (!this.demonstracaoResultadoCompartilhar.id) {
            const response = await http.post('/demonstracaoResultadoVersao/adicionarVersoes', data)
            if (response.data.id) {
              this.demonstracaoResultadoCompartilhar.id = response.data.id
              this.demonstracaoResultadoVersoes.push({ ...this.demonstracaoResultadoCompartilhar })
              this.clearFields()
              this.isShowModal = false
            } else {
              alert(response.request.responseText)
            }
          }
        } else {
          if (!this.demonstracaoResultadoVersaoConfig.descricao) {
            alert('Descrição da linha não informada!')
            return
          }
          if (!this.demonstracaoResultadoVersaoConfig.sequencial) {
            alert('Sequencial da linha não informado!')
            return
          }
          if (!this.demonstracaoResultadoVersaoConfig.formula) {
            alert('Fórmula da linha não informada!')
            return
          }

          data = {
            id: this.demonstracaoResultadoVersaoConfig.id,
            descricao: this.demonstracaoResultadoVersaoConfig.descricao,
            sequencial: this.demonstracaoResultadoVersaoConfig.sequencial,
            e_negrito: this.demonstracaoResultadoVersaoConfig.eNegrito === 'S',
            indentacao: this.demonstracaoResultadoVersaoConfig.indentacao,
            formula: this.demonstracaoResultadoVersaoConfig.formula,
            tipo_evolucao_desejada: this.demonstracaoResultadoVersaoConfig.tipo_evolucao_desejada,
            demonstracao_resultado_versao: this.dreVersaoSelecionado.id,
            referencia_av: this.demonstracaoResultadoVersaoConfig.referencia_av
          }

          if (!this.demonstracaoResultadoVersaoConfig.id) {
            const response = await http.post('/demonstracaoResultadoVersaoConfig/adicionar', data)
            if (response.data.id) {
              this.demonstracaoResultadoVersaoConfig.id = response.data.id
              this.linhasDemonstracaoResultado.push({ ...this.demonstracaoResultadoVersaoConfig })
              this.clearFields()
              this.isShowModal = false
            } else {
              alert(response.request.responseText)
            }
          } else {
            const response = await http.put('/demonstracaoResultadoVersaoConfig/editar/' + this.demonstracaoResultadoVersaoConfig.id, data)
            this.linhasDemonstracaoResultado[this.demonstracaoResultadoVersaoConfig.index].descricao = response.data.descricao
            this.linhasDemonstracaoResultado[this.demonstracaoResultadoVersaoConfig.index].sequencial = response.data.sequencial
            this.linhasDemonstracaoResultado[this.demonstracaoResultadoVersaoConfig.index].e_negrito = response.data.e_negrito
            this.linhasDemonstracaoResultado[this.demonstracaoResultadoVersaoConfig.index].indentacao = response.data.indentacao
            this.linhasDemonstracaoResultado[this.demonstracaoResultadoVersaoConfig.index].formula = response.data.formula
            this.linhasDemonstracaoResultado[this.demonstracaoResultadoVersaoConfig.index].tipo_evolucao_desejada = response.data.tipo_evolucao_desejada
            this.linhasDemonstracaoResultado[this.demonstracaoResultadoVersaoConfig.index].referencia_av = response.data.referencia_av
            this.linhasDemonstracaoResultado[this.demonstracaoResultadoVersaoConfig.index].demonstracao_resultado_versao = this.dreVersaoSelecionado
            this.isShowModal = false
          }
        }
      } catch (e) {
        alert(e.response?.data || 'Erro ao salvar!')
      }
    }
  },
  created() {
    http.get('versoesPlanoContas/listar')
      .then(response => {
        this.versoesPlanoContas = response.data.results || []
      })
      .catch(e => {
        console.error('Erro ao carregar versões do plano de contas:', e)
        this.versoesPlanoContas = []
      })

    http.get('demonstracaoResultadoVersao/listar/')
      .then(response => {
        this.demonstrativosResultados = response.data.results || []
        this.previous = response.data.previous
        this.next = response.data.next
        this.page = response.data.page
        this.numpages = response.data.numpages
      })
      .catch(e => {
        console.error('Erro ao carregar demonstrações de resultados:', e)
        this.demonstrativosResultados = []
      })
  }
}
</script>

<style scoped>
</style>